import React, { useState, useEffect } from "react";
import arrow from "Resources/ImagesNew/arrow.png";
import Icon from "@mdi/react";
import { mdiHelpCircleOutline } from "@mdi/js";
import HuongDanSuDungApi from "service/HeThongNT/HuongDanSuDungApi";

export const Breadcrumb = ({ text1, text2, link }) => {
  return (
    <div className="row">
      <div id="breadcrumb" className=" col-sm-12">
        {/* <div className="col-sm-9"> */}
        <ul className="breadcrumb ">
          <li>
            <a href={link}>
              <img src={arrow} alt="" /> {text1}
            </a>
          </li>
          <li>{text2}</li>
        </ul>
        {/* </div> */}
        {/* {data.Name !== "" && (
          <div
            className="col-sm-3 formHelp"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <a
              href={() => false}
              onClick={(e) => linkHelp(window.location.pathname)}
            >
              <Icon
                path={mdiHelpCircleOutline}
                title="Hướng dẫn sử dụng"
                size={1.1}
                // color="#02499b"
              />{" "}
              Xem hướng dẫn
            </a>
          </div>
        )} */}
      </div>
    </div>
  );
};
